import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { paperGoodsReceiptBusiness } from "api/bussiness/paper-material/paper-goods-receipt";
import { downloadFile } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { ExportExcelDialog } from "share-components/mui-wrap/dialog/export-excel-dialog";

export const ExportExcel = observer(() => {
  const {
    paperInventoryManagement: {
      paperGoodsReceiptStore: {
        excelParams: {
          receiptDateRangeFilter: {
            fromAsDayJs: fromReceiptAsDayJs,
            from: fromReceipt,
            to: toReceipt,
            toAsDayJs: toReceiptAsDayJs,
            setProp: setReceiptDateRange,
          },
          showZeroQuantity,
          setProp: setExcelParamsProp,
        },
        openExportExcel,
        setProp,
      },
    },
  } = useStores();
  const handleClose = () => {
    setProp("openExportExcel", false);
  };

  const fromReceiptDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setReceiptDateRange("from", value ? value.toString() : null);
    },
    [setReceiptDateRange],
  );

  const toReceiptDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setReceiptDateRange("to", value ? value.toString() : null);
    },
    [setReceiptDateRange],
  );

  const exportExcel = useCallback(async () => {
    try {
      const res = await paperGoodsReceiptBusiness.exportExcel({
        fromReceiptDate:
          fromReceiptAsDayJs?.isValid() && fromReceipt ? fromReceipt : "",
        toReceiptDate:
          toReceiptAsDayJs?.isValid() && toReceipt ? toReceipt : "",
        showZeroQuantity: showZeroQuantity,
      });
      downloadFile(
        res,
        "Nhap_Kho_Giay_Tu_" +
          (dateTimeDisplay(fromReceipt) || "") +
          "_den_" +
          (dateTimeDisplay(toReceipt) || "") +
          ".xlsx",
      );
    } catch (ex) {
    } finally {
    }
  }, [
    fromReceipt,
    fromReceiptAsDayJs,
    toReceipt,
    toReceiptAsDayJs,
    showZeroQuantity,
  ]);

  const showZeroQuantityHandler = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setExcelParamsProp("showZeroQuantity", checked);
    },
    [setExcelParamsProp],
  );

  return (
    <ExportExcelDialog
      open={openExportExcel}
      handleClose={handleClose}
      exportBtnDisabled={false}
      exportHandler={exportExcel}
    >
      <Stack direction={"column"} spacing={2}>
        <Stack direction={"row"} sx={{ paddingTop: 1 }}>
          <DateRange
            label={"Ngày nhập kho"}
            fromDate={fromReceiptAsDayJs}
            toDate={toReceiptAsDayJs}
            onFromDateChanged={fromReceiptDateChangedHandler}
            onToDateChanged={toReceiptDateChangedHandler}
          ></DateRange>
        </Stack>
        <Stack>
          <FormControlLabel
            control={
              <Checkbox
                checked={showZeroQuantity}
                onChange={showZeroQuantityHandler}
              />
            }
            label="Gồm tồn bằng 0"
          />
        </Stack>
      </Stack>
    </ExportExcelDialog>
  );
});
